import { RefreshCw, CheckCircle, XCircle } from 'lucide-react';

export default function RefundContent() {
  return (
    <div className="prose prose-sm prose-invert max-w-none">
      {/* Header */}
      <div className="flex items-center gap-3 mb-6 pb-4 border-b border-gray-800">
        <div className="w-10 h-10 bg-gradient-to-br from-orange-500 to-red-600 rounded-lg flex items-center justify-center flex-shrink-0">
          <RefreshCw className="text-white" size={20} />
        </div>
        <div>
          <h1 className="text-2xl font-bold text-white m-0">Refund Policy</h1>
          <p className="text-sm text-gray-400 mt-0.5 m-0">นโยบายการคืนเงิน</p>
        </div>
      </div>

      {/* Highlight */}
      <div className="bg-gradient-to-r from-orange-900/30 to-red-900/30 border border-orange-700/50 rounded-lg p-4 mb-6">
        <div className="flex items-start gap-3">
          <RefreshCw className="text-orange-400 flex-shrink-0 mt-0.5" size={20} />
          <div>
            <p className="text-white font-semibold text-sm m-0 mb-1">การคืนเงินภายใน 24 ชั่วโมง</p>
            <p className="text-gray-300 text-xs m-0">
              คืนเงิน <strong className="text-orange-400">100%</strong> หากพบปัญหาทางเทคนิคร้ายแรงจากระบบ 
              และ<strong className="text-orange-400">ยังไม่ได้เริ่มใช้งาน</strong>
            </p>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="space-y-6 text-sm">
        {/* Section 1 */}
        <section>
          <h2 className="text-lg font-semibold text-white mb-3">1. เงื่อนไขการคืนเงิน</h2>
          
          {/* Can Refund */}
          <div className="mb-4">
            <div className="flex items-center gap-2 mb-2">
              <CheckCircle className="text-green-400" size={18} />
              <p className="text-white font-medium m-0">สามารถขอคืนเงินได้ (✅)</p>
            </div>
            <div className="bg-green-900/20 border border-green-700/50 rounded p-3 space-y-2 text-xs">
              <div>
                <p className="text-green-300 font-medium">• ชำระแล้ว แต่ระบบไม่เปิดใช้งานแผน</p>
                <p className="text-gray-400 ml-4">ชำระเงินเรียบร้อย แต่แผนไม่เปิดภายใน 24 ชม.</p>
              </div>
              <div>
                <p className="text-green-300 font-medium">• ชำระเงินซ้ำโดยไม่ตั้งใจ</p>
                <p className="text-gray-400 ml-4">โอนซ้ำ 2 ครั้ง หรือโอนผิดจำนวน</p>
              </div>
              <div>
                <p className="text-green-300 font-medium">• ระบบมีปัญหาร้ายแรง (ภายใน 24 ชม.)</p>
                <p className="text-gray-400 ml-4">ระบบ Down ทั้งเว็บ, ไม่สามารถสร้าง Page ได้เลย</p>
              </div>
              <div className="bg-green-800/30 rounded p-2 mt-2">
                <p className="text-green-200 font-medium m-0">📌 เงื่อนไข: ยังไม่ได้สร้าง Landing Page เลย</p>
              </div>
            </div>
          </div>

          {/* Cannot Refund */}
          <div>
            <div className="flex items-center gap-2 mb-2">
              <XCircle className="text-red-400" size={18} />
              <p className="text-white font-medium m-0">ไม่สามารถขอคืนเงินได้ (❌)</p>
            </div>
            <div className="bg-red-900/20 border border-red-700/50 rounded p-3 space-y-2 text-xs">
              <div className="flex items-start gap-2">
                <span className="text-red-400">⏰</span>
                <div>
                  <p className="text-red-300 font-medium m-0">ใช้บริการมาแล้วเกิน 24 ชั่วโมง</p>
                  <p className="text-gray-400 m-0">แม้ไม่ได้ใช้งานเลย ก็ไม่สามารถขอคืนได้</p>
                </div>
              </div>
              <div className="flex items-start gap-2">
                <span className="text-red-400">📄</span>
                <div>
                  <p className="text-red-300 font-medium m-0">สร้าง Landing Page แล้ว (แม้แค่ 1 หน้า)</p>
                  <p className="text-gray-400 m-0">ถือว่าเริ่มใช้บริการแล้ว</p>
                </div>
              </div>
              <div className="flex items-start gap-2">
                <span className="text-red-400">🔧</span>
                <div>
                  <p className="text-red-300 font-medium m-0">ใช้งานฟีเจอร์แล้ว</p>
                  <p className="text-gray-400 m-0">Analytics, Tracking, Redirect</p>
                </div>
              </div>
              <div className="flex items-start gap-2">
                <span className="text-red-400">🔄</span>
                <div>
                  <p className="text-red-300 font-medium m-0">เปลี่ยนใจ / ไม่ต้องการใช้ต่อ</p>
                  <p className="text-gray-400 m-0">ระบบทำงานปกติ แต่ไม่ชอบ</p>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-orange-900/20 border border-orange-700/50 rounded p-3 mt-3">
            <p className="text-orange-300 text-xs m-0">
              <strong>📌 สำคัญ:</strong> นโยบาย 24 ชั่วโมงนี้ป้องกันการเอาเปรียบ 
              (ใช้งานเต็มที่แล้วขอคืนเงิน) หากมีปัญหาจริงๆ เรายินดีคืนเงิน 100%
            </p>
          </div>
        </section>

        {/* Section 2 */}
        <section>
          <h2 className="text-lg font-semibold text-white mb-3">2. ขั้นตอนการขอคืนเงิน</h2>
          <div className="space-y-2">
            <div className="bg-blue-900/20 border-l-4 border-blue-500 rounded p-3">
              <p className="text-white font-medium text-xs m-0 mb-1">📧 Step 1: ส่งคำขอคืนเงิน</p>
              <p className="text-gray-300 text-xs m-0">
                Email: support@hitzlink.com • 
                หัวข้อ: "ขอคืนเงิน - [ชื่อ/อีเมล]" • 
                ระบุเหตุผล + แนบหลักฐาน
              </p>
            </div>
            <div className="bg-purple-900/20 border-l-4 border-purple-500 rounded p-3">
              <p className="text-white font-medium text-xs m-0 mb-1">🔍 Step 2: ทีมตรวจสอบ</p>
              <p className="text-gray-300 text-xs m-0">
                ตรวจสอบภายใน 1-2 วันทำการ • อาจขอข้อมูลเพิ่มเติม
              </p>
            </div>
            <div className="bg-green-900/20 border-l-4 border-green-500 rounded p-3">
              <p className="text-white font-medium text-xs m-0 mb-1">✅ Step 3: อนุมัติและคืนเงิน</p>
              <p className="text-gray-300 text-xs m-0">
                แจ้งผล 1-2 วัน • โอนเงินคืน 7-14 วันทำการ
              </p>
            </div>
          </div>
        </section>

        {/* Section 3 */}
        <section>
          <h2 className="text-lg font-semibold text-white mb-3">3. การยกเลิกและดาวน์เกรดแผน</h2>
          <div className="grid sm:grid-cols-2 gap-3 text-xs">
            <div className="bg-gray-800/50 border border-gray-700 rounded p-3">
              <p className="text-blue-400 font-medium mb-2">🚫 การยกเลิกแผน</p>
              <ul className="text-gray-300 space-y-1">
                <li>• ยกเลิกได้ทุกเมื่อ (ไม่มีค่าปรับ)</li>
                <li>• ใช้งานได้จนสิ้นรอบบิล</li>
                <li>• ดาวน์เกรดเป็น Free อัตโนมัติ</li>
                <li>• ไม่คืนเงินส่วนที่เหลือ</li>
              </ul>
            </div>
            <div className="bg-gray-800/50 border border-gray-700 rounded p-3">
              <p className="text-orange-400 font-medium mb-2">📉 การดาวน์เกรด</p>
              <ul className="text-gray-300 space-y-1">
                <li>• ดาวน์เกรดได้ทันที</li>
                <li>• ฟีเจอร์พิเศษหยุดทันที</li>
                <li>• Pages เกินขอบเขตถูกปิด</li>
                <li>• ไม่คืนเงินส่วนต่าง</li>
              </ul>
            </div>
          </div>
        </section>

        {/* FAQ */}
        <section>
          <h2 className="text-lg font-semibold text-white mb-3">4. คำถามที่พบบ่อย</h2>
          <div className="space-y-2 text-xs">
            <details className="bg-gray-800/30 rounded p-3 cursor-pointer">
              <summary className="text-white font-medium">Q: ชำระเงินแล้ว 12 ชม. ไม่ชอบ UI ขอคืนได้ไหม?</summary>
              <p className="text-gray-300 mt-2 ml-4">
                A: ❌ ไม่ได้ครับ - การ "ไม่ชอบ" ถือเป็นการเปลี่ยนใจ ต้องเป็นปัญหาจากระบบ + ยังไม่ได้สร้าง Page
              </p>
            </details>
            <details className="bg-gray-800/30 rounded p-3 cursor-pointer">
              <summary className="text-white font-medium">Q: สร้าง Page 1 หน้าแล้ว ขอคืนได้ไหม?</summary>
              <p className="text-gray-300 mt-2 ml-4">
                A: ❌ ไม่ได้ครับ - เมื่อสร้าง Page แล้ว = ถือว่าเริ่มใช้บริการแล้ว
              </p>
            </details>
            <details className="bg-gray-800/30 rounded p-3 cursor-pointer">
              <summary className="text-white font-medium">Q: ใช้เวลานานแค่ไหนถึงได้เงินคืน?</summary>
              <p className="text-gray-300 mt-2 ml-4">
                A: ตรวจสอบ 1-2 วันทำการ → โอนคืน 7-14 วันทำการ (รวม 8-16 วันทำการ)
              </p>
            </details>
            <details className="bg-gray-800/30 rounded p-3 cursor-pointer">
              <summary className="text-white font-medium">Q: ชำระมา 25 ชม. แล้ว ขอคืนได้ไหม?</summary>
              <p className="text-gray-300 mt-2 ml-4">
                A: ❌ ไม่ได้ครับ - หมดเวลา 24 ชม. แล้ว แม้ยังไม่ได้ใช้งานก็ไม่สามารถขอคืนได้
              </p>
            </details>
          </div>
        </section>

        {/* Contact */}
        <div className="mt-6 pt-4 border-t border-gray-800">
          <div className="bg-orange-900/20 border border-orange-700/50 rounded p-4">
            <p className="text-white font-semibold text-sm mb-2">📧 ติดต่อขอคืนเงิน</p>
            <div className="text-xs text-gray-300 space-y-1">
              <p><strong>Email:</strong> support@hitzlink.com</p>
              <p><strong>Subject:</strong> "ขอคืนเงิน - [ชื่อบัญชี/อีเมล]"</p>
              <p><strong>Hours:</strong> Mon-Fri, 9:00-18:00</p>
            </div>
            <p className="text-xs text-gray-400 mt-3 m-0">
              💡 <strong>เคล็ดลับ:</strong> ลองติดต่อ Support ก่อนขอคืนเงิน 
              เราอาจช่วยแก้ไขปัญหาได้โดยไม่ต้องคืนเงิน!
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

